<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-center">
            <!-- Email content   -->
            <div class="repeater_wrapper mt-6">
              <h5>البريد الالكتروني</h5>
              <div class="row">
                <div class="col-lg-10 row">
                  <!-- ********** Row Data ********** -->
                  <div
                    class="col-6"
                    v-for="(item, itemIndex) in data.public_emails"
                    :key="itemIndex"
                  >
                    <div class="input_wrapper top_label">
                      <input
                        type="email"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="data.public_emails[itemIndex]"
                      />
                      <label for="name_input" class="form-label">
                        البريد الالكتروني رقم {{ itemIndex + 1 }}
                      </label>
                    </div>
                  </div>
                </div>
                <!-- ********** Row Control Buttons ********** -->
                <div class="col-1 py-0 d-flex justify-center align-center mx-1">
                  <span class="append" @click="appendRow">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div class="col-1 py-0 d-flex justify-center align-center mx-1">
                  <span
                    v-if="data.public_emails.length > 1"
                    class="append"
                    @click="deleteRow(itemIndex)"
                  >
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
            </div>
            <!-- Social Media -->
            <div class="repeater_wrapper mt-6">
              <h5>روابط التواصل الاجتماعي</h5>
              <div class="row">
                <div class="col-lg-10 row">
                  <!-- ********** Row Data ********** -->
                  <div
                    class="col-6"
                    v-for="(item, itemIndex) in data.socials"
                    :key="itemIndex"
                  >
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="item.social_link"
                      />
                      <label for="name_input" class="form-label">
                        الرابط
                      </label>
                    </div>
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="item.social_title"
                      />
                      <label for="name_input" class="form-label">
                        عنوان
                      </label>
                    </div>
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="item.social_icon"
                      />
                      <label for="name_input" class="form-label">
                        كود الايكونة في مكتبة font awesome
                      </label>
                    </div>
                  </div>
                </div>
                <!-- ********** Row Control Buttons ********** -->
                <div class="col-1 py-0 d-flex justify-center align-center mx-1">
                  <span class="append" @click="appendSocailRow">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div class="col-1 py-0 d-flex justify-center align-center mx-1">
                  <span
                    v-if="data.socials.length > 1"
                    class="append"
                    @click="deleteSocialRow()"
                  >
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons_wrapper">
            <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
              {{ $t("forms.submit") }}
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.settings.title"),
          disabled: false,
          href: "/settings/mails",
        },
        {
          text: this.$t("breadcrumb.settings.update"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        public_emails: ["", ""],
        socials: [
          {
            social_icon: null,
            social_title: null,
            social_link: null,
          },
        ],
      },
    };
  },

  methods: {
    appendRow() {
      this.data.public_emails.push("");
    },
    deleteRow() {
      this.data.public_emails.splice(-1);
    },
    appendSocailRow() {
      this.data.socials.push({
        social_icon: null,
        social_title: null,
        social_link: null,
      });
    },
    deleteSocialRow() {
      this.data.socials.splice(-1);
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (this.public_emails) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل البريد الالكتروني",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      }

      this.submitData();
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      this.data.public_emails.forEach((item, index) => {
        submit_data.append(`public_emails[${index}]`, item);
      });
      this.data.socials.forEach((item, index) => {
        submit_data.append(
          `socials[${index}][social_title]`,
          item.social_title
        );
        submit_data.append(`socials[${index}][social_icon]`, item.social_icon);
        submit_data.append(`socials[${index}][social_link]`, item.social_link);
      });
      this.axios({
        method: "POST",
        url: "setting",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/settings/mails" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.axios({
        method: "GET",
        url: "setting",
      })
        .then((res) => {
          this.data = res.data.data;
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    this.getData();
  },
};
</script>
